import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const SentenceExpander = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14929)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#F4F4F4"
          />
          <rect
            x="45.75"
            y="34.75"
            width="61.5"
            height="30.6429"
            rx="4.05"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M102.937 35.2859L46.2857 63.3788C46.2857 63.3788 46.6836 64.147 47.3919 64.4243C48.1002 64.7016 49.0608 64.8574 50.0625 64.8574H102.937C103.939 64.8574 104.9 64.7016 105.608 64.4243C106.316 64.147 106.714 63.7709 106.714 63.3788V36.7645C106.714 36.3724 106.316 35.9963 105.608 35.719C104.9 35.4417 102.937 35.2859 102.937 35.2859Z"
            fill="#E3E3E3"
          />
          <path
            d="M58.9714 46.6857H82.8797"
            stroke="#191919"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M58.9714 53.8857H89.7106"
            stroke="#191919"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="45.9"
            y="34.9"
            width="61.2"
            height="30.3429"
            rx="3.9"
            stroke="#191919"
            strokeWidth="1.8"
          />
          <g clipPath="url(#clip1_1503_14929)">
            <path
              d="M115.352 84.5741L120.961 90.1759L115.352 95.7778"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M120.961 90.1759C110.374 90.1759 95.901 90.9139 94.0395 76.6296"
              stroke="#1E1E1E"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <rect
            x="139.75"
            y="34.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M196.938 35.2855L140.286 113.457C140.286 113.457 140.684 115.595 141.392 116.366C142.1 117.138 143.061 117.571 144.063 117.571H196.938C197.939 117.571 198.9 117.138 199.608 116.366C200.316 115.595 200.714 114.548 200.714 113.457V39.3997C200.714 38.3086 200.316 37.2621 199.608 36.4905C198.9 35.7189 196.938 35.2855 196.938 35.2855Z"
            fill="#E3E3E3"
          />
          <path
            d="M153.143 53.2857H178.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 61H186.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 68.7143H178.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 76.4286H186.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 84.1429H186.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 91.8571H186.078"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M153.143 99.5714H178.759"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="139.75"
            y="34.75"
            width="61.5"
            height="83.3571"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M125.404 35.6141L122.999 38.0195L114.981 30.0016L117.386 27.5962C118.455 26.5613 119.888 25.9881 121.376 26.0002C122.864 26.0123 124.287 26.6087 125.339 27.6608C126.391 28.7129 126.988 30.1364 127 31.6242C127.012 33.1121 126.439 34.5451 125.404 35.6141Z"
            fill="#FF808C"
          />
          <path
            d="M106.225 54.7928L95 58L98.2072 46.7749L106.225 54.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M114.981 30.0049L98.2071 46.7783L106.225 54.7963L122.998 38.0228L114.981 30.0049Z"
            fill="#FFEF5E"
          />
          <path
            d="M125.404 35.6141L122.999 38.0195L114.981 30.0016L117.386 27.5962C118.455 26.5613 119.888 25.9881 121.376 26.0002C122.864 26.0123 124.287 26.6087 125.339 27.6608C126.391 28.7129 126.988 30.1364 127 31.6242C127.012 33.1121 126.439 34.5451 125.404 35.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M106.225 54.7928L95 58L98.2072 46.7749L106.225 54.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.981 30.0049L98.2071 46.7783L106.225 54.7963L122.998 38.0228L114.981 30.0049Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14929">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14929">
            <rect
              width="22"
              height="31"
              fill="white"
              transform="matrix(-4.37114e-08 1 1 4.37114e-08 92 75)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
